module.exports = __webpack_public_path__ + "media/flags/de-flag-f37644fb.svg";